import request from '@/utils/request'
// 获取个人资料
export function getSelfInfo () {
  return request({
    url: '/hr/userextatt/selfInfo',
    method: 'GET'
  })
}

// 获取话题列表 isRelease 0草稿箱
export function getDraftList (params) {
  return request({
    url: '/hr/topic/page/self',
    method: 'GET',
	params
  })
}

// 获取收藏话题列表
export function getCollectPage (params) {
  return request({
    url: '/hr/topic/page/collection',
    method: 'GET',
	params
  })
}
// 获取软件收藏列表
export function getCollectSoft (params) {
  return request({
    url: '/hr/topictheme/page/collection',
    method: 'GET',
	params
  })
}
// 获取评论
export function getCommentList (params) {
  return request({
    url: '/hr/topicreply/mySent',
    method: 'GET',
	params
  })
}
// 获取用户关注列表
export function getFollowList (params) {
  return request({
    url: '/hr/userfollower/page/self',
    method: 'GET',
	params
  })
}
// 关注
export function userFollow (data) {
  return request({
    url: '/hr/userfollower/follow',
    method: 'POST',
	data
  })
}
// 取关
export function unfollow (data) {
 return request({
   url: '/hr/userfollower/unfollow',
   method: 'POST',
 	data
 })
}